export const ToolConfigurationRoutesConfig = {
  toolConfigurationPage: "/tool-configuration",
  alertConfigurationPage: "/tool-configuration/system-alert",
  userManagementPage: "/tool-configuration/user-management",
};
